const referrer = ['https://www.amio-ads.ru/', 'https://amio-ads.ru/', 'www.amio-ads.ru']
export function setReferrer(){
  if(referrer.includes(window.location.hostname)){
    window.sessionStorage.setItem('referrer', window.location.hostname)
  }
}

export function isReferrer(){
  return referrer.includes(window.location.hostname)
}